<template>
    <div class="back-top" v-show="show" @click="handleClick">
        <div class="ivu-back-top-inner">
            <i class="ivu-icon ivu-icon-ios-arrow-up"></i>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                height: 400,
                show: false,
                duration: 1000
            }
        },
        methods: {
            handleClick() {
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                this.scrollTop(document.body, sTop, 0, this.duration);
            },
            handleScroll() {
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                this.show = sTop >= this.height;
            },
            scrollTop(el, from = 0, to, duration = 500, endCallback) {
                if (!window.requestAnimationFrame) {
                    window.requestAnimationFrame = (
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame ||
                        window.msRequestAnimationFrame ||
                        function (callback) {
                            return window.setTimeout(callback, 1000 / 60);
                        }
                    );
                }
                const difference = Math.abs(from - to);
                const step = Math.ceil(difference / duration * 50);

                function scroll(start, end, step) {
                    if (start === end) {
                        endCallback && endCallback();
                        return;
                    }

                    let d = (start + step > end) ? end : start + step;
                    if (start > end) {
                        d = (start - step < end) ? end : start - step;
                    }

                    if (el === window) {
                        window.scrollTo(d, d);
                    } else {
                        el.scrollTop = d;
                    }
                    window.requestAnimationFrame(() => scroll(d, end, step));
                }

                scroll(from, to, step);
            }
        },
        created() {
            document.body.addEventListener('scroll', this.handleScroll, false);
        }
    }
</script>

<style lang="scss" scoped>
    .back-top {
        z-index: 10;
        position: fixed;
        cursor: pointer;
        right: 50px;
        bottom: 50px;

        i {
            color: #fff;
            font-size: 24px;
            padding: 8px 12px;
        }
    }
</style>